export default "__VITE_PUBLIC_ASSET__009f33f4__"